<template>
  <card class="flat my-0" body-classes="px-0 py-0" footer-classes="pb-2">
    <template #header>{{ '' }} </template>
    <div
      draggable="true"
      @dragover.prevent="onDragover"
      @dragleave.prevent="onDragleave"
      @drop.prevent="onDrop"
    >
      <el-table
        :data="queriedData"
        row-key="uid"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="rows => (selectedRows = rows)"
      >
        <template #empty>
          <b-spinner v-if="loading" label="Loading..."></b-spinner>
          <span v-else>There are no documents.</span>
        </template>
        <el-table-column type="selection"> </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.label"
          v-bind="column"
        >
          <template v-if="column.prop === 'create_date'" #default="{row}">
            {{ row.create_date | toDateFormat }}
          </template>
        </el-table-column>
        <el-table-column min-width="220px" align="right" label="Actions">
          <template #default="{ $index, row }">
            <div class="d-flex flex-wrap">
              <base-button
                @click.native="downloadByRow(row)"
                class="like btn-link my-1"
                type="success"
                size="sm"
                icon
                :id="row.uid + '_translated'"
              >
                <i class="text-white fa fa-download"> </i>
              </base-button>
              <base-button
                @click.native="deleteByRow(row)"
                class="remove btn-link my-1"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white fa fa-trash"></i>
              </base-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 training-footer">
      <div></div>
      <div class="d-flex mb-4 mx-auto">
        <base-button @click="$router.push('/training')">
          Add Training Files
        </base-button>
        <base-button
          @click="deleteSelectedRows"
          type="warning"
          :disabled="selectedRows.length === 0"
        >
          Delete Document
        </base-button>
      </div>
      <base-pagination
        class="pagination-no-border training-footer-pagination"
        ref="pagination"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  mixins: [clientPaginationMixin],
  data: () => ({
    dragover: false,
    files: [],
    loading: false,
    selectedRows: [],
    columns: [
      {
        prop: 'name',
        label: 'file name',
        sortable: true,
        minWidth: 300,
      },
      {
        prop: 'category',
        label: 'category',
        sortable: true,
        minWidth: 200,
      },
      {
        prop: 'create_date',
        label: 'upload date',
        sortable: true,
        minWidth: 200,
      },
    ],
  }),
  computed: {
    tableData() {
      return this.files
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      this.files = await this.$slowbro
        .get(`/me/company/files`)
        .then(r => r.data)
    },
    onDragover() {
      this.dragover = true
    },
    onDragleave() {
      this.dragover = false
    },
    onDrop(e) {
      this.dragover = false
      this.$emit('drop', e.dataTransfer?.files)
    },
    removeFiles(files) {
      const removed = files.map(f => f.uid)
      this.files = this.files.filter(f => !removed.includes(f.uid))
    },
    async downloadByRow(row) {
      const response = await this.$slowbro.get(
        `/me/company/files/${row.uid}/download`,
        {
          headers: {
            Accept:
              'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,text/plain',
          },
          responseType: 'blob',
        }
      )
      const blob = new Blob([response.data])
      const contentDisposition = response.headers['content-disposition']
      const filename = contentDisposition.split('filename=')[1] || 'file.docx'
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', decodeURIComponent(filename))
      document.body.appendChild(link)
      link.click()
    },
    async deleteByRow(row) {
      const confirmed = await this.confrimDeletion()
      if (!confirmed.value) return
      await this.$slowbro.post(`/me/company/files/${row.uid}/delete`)
      this.removeFiles([row])
    },
    async deleteSelectedRows() {
      const confirmed = await this.confrimDeletion()
      if (!confirmed.value) return
      await this.$sync.deleteFiles(this.selectedRows, file =>
        this.$slowbro.post(`/me/company/files/${file.uid}/delete`)
      )
      this.removeFiles(this.selectedRows)
    },
    confrimDeletion() {
      return this.$swal.fire({
        message:
          'This operation is irreversible. Are you sure you want to delete?',
        showCancelButton: true,
        type: 'info',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.training-footer {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  &-pagination {
    justify-self: end;
  }
}
</style>
